import React from "react";
import Inview from "./inview";

class LingoHomepageCustomBlock extends React.Component {
    render() {
        // to make a banner: remove className `container row` and add class banner
        return (
            <div
                className="custom-block lingo-homepage margin-t-xxl banner"
                style={{ backgroundColor: "#F2F2F2" }}
            >
                <Inview className="lingo-background-image">
                    <div className="container margin-xl padding-t-xxl padding-b-xxl">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                &nbsp;
                            </div>
                            <div className="lingo-text-box col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                <h1
                                    className="font-xxlarge"
                                    style={{
                                        color: "#FF6161"
                                    }}
                                >
                                    Lingo
                                    <span
                                        className="font-xlarge"
                                        style={{
                                            color: "#000",
                                            marginLeft: "8px"
                                        }}
                                    >
                                        Store
                                    </span>
                                </h1>
                                <p
                                    style={{
                                        fontSize: "18px",
                                        maxWidth: "400px"
                                    }}
                                >
                                    Ready-to-use asset packs to help you build a
                                    central library for all your design needs.
                                </p>
                                <a
                                    className="lingo-link"
                                    style={{
                                        fontSize: "18px",
                                        color: "#000000"
                                    }}
                                    href="https://www.lingoapp.com/store?ref=nounproject&utm_source=thenounproject.com&utm_medium=ad&utm_campaign=store"
                                >
                                    Shop All Kits
                                </a>
                            </div>
                        </div>
                    </div>
                </Inview>
            </div>
        );
    }
}

module.exports = LingoHomepageCustomBlock;
